<template>
  <v-row justify="center">
    <v-dialog v-model="IsMCUVisible" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on"
          ><v-icon class="pr-2">mdi-account-plus </v-icon> Nouveau Utilisateur
        </v-btn>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Création d'un nouveau utilisateur</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  color="#51bdcb"
                  label="E-mail de l'utilisateur"
                  :rules="emailRules"
                  required
                  v-model="email"
                ></v-text-field>
              </v-col>
              <v-col v-if="emailError">
                <v-alert
                  border="right"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  Adresse mail invalide
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules"
                  rows="1"
                  color="#51bdcb"
                  label="Mot de passe"
                  required
                  class="field"
                  v-model="password"
                  @click:append="show = !show"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="roles"
                  v-model="role"
                  :rules="[(v) => !!v || 'Un rôle doit être sélectionné']"
                  name="role"
                  label="Selection du rôle"
                  color="#51bdcb"
                  item-color="dark"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="blankError">
                <v-alert
                  border="right"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  Veuillez remplir tous les champs s'il vous plaît
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#51bdcb" text @click="closeMCU"> Annuler </v-btn>
          <v-btn color="#51bdcb" text @click="createUser"> Créer </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="isErrorMessageDisplayed"> <PopUpError /></template>
  </v-row>
</template>

<script>
import { ADD_USER } from '../graphql/GraphQLMutations';
import { GET_ALL_USERS } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

export default {
  name: 'ModalCreateUser',

  components: {
    PopUpError,
  },

  data: () => ({
    show: false,
    IsMCUVisible: false,
    blankError: false,
    emailError: false,
    email: '',
    password: '',
    role: '',
    roles: ['Admin', 'Utilisateur'],
    reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    emailRules: [
      (v) => !!v || "L'e-mail doit être rempli",
      (v) => /.+@.+\..+/.test(v) || "L'e-mail doit être valide",
    ],
    passwordRules: [
      (v) => !!v || 'Le mot de passe doit être rempli',
      (v) =>
        v.length >= 4 || 'Le mot de passe doit contenir au moins 4 caractères',
    ],
    isErrorMessageDisplayed: false,
  }),

  methods: {
    closeMCU() {
      this.blankError = false;
      this.IsMCUVisible = false;
    },
    createUser() {
      // reset error
      this.isErrorMessageDisplayed = false;
      if (this.email && this.password.length >= 4 && this.role !== 0) {
        if (this.reg.test(this.email)) {
          this.$apollo
            .mutate({
              mutation: ADD_USER,
              variables: {
                email: this.email,
                password: this.password,
                role: this.role,
              },
              update: (cache, { data: { createUser } }) => {
                const data = cache.readQuery({ query: GET_ALL_USERS });
                data.getAllUsers.push(createUser);
                cache.writeQuery({ query: GET_ALL_USERS, data });
              },
            })
            .then(() => {
              this.IsMCUVisible = false;
            })
            .catch(() => {
              this.isErrorMessageDisplayed = true;
            });
        } else {
          this.emailError = true;
        }
      } else {
        this.blankError = true;
      }
    },
  },
};
</script>
